import * as Dialog from '@radix-ui/react-dialog';
import '@/app/styles.scss';
import { useModalStore } from '@/shared/lib/store/model/modal.store';

export const GlobalModal = () => {
    const { modals, closeModal } = useModalStore();

    return (
        <>
            {modals.map((modal) => (
                <Dialog.Root
                    key={modal.id}
                    open={modal.open}
                    onOpenChange={(isOpen) => {
                        if (!isOpen) {
                            if (modal.id != 'eval-viewer-stnt') closeModal(modal.id);
                        }
                    }}
                >
                    <Dialog.Title>{modal.title + '팝업'}</Dialog.Title>
                    <Dialog.Portal>
                        <Dialog.Content className="DialogContent">
                            <div className="ki-dim ttukttak">
                                <div className="pos-center">
                                    {modal.isCustom ? (
                                        modal.initContents()
                                    ) : (
                                        <div
                                            className={
                                                modal.containerClass ??
                                                'pop_wrap publish_option complite complite_class_report1'
                                            }
                                        >
                                            <div className="modal_header">
                                                <div className="title">{modal.title}</div>
                                            </div>
                                            {modal.initContents()}
                                            <Dialog.Close asChild>
                                                <button type="button" className="btn-x btn-x-white">
                                                    <span className="sr-only">팝업 닫기</span>
                                                </button>
                                            </Dialog.Close>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Dialog.Content>
                    </Dialog.Portal>
                </Dialog.Root>
            ))}
        </>
    );
};
